<!-- <div class="row"> -->
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Causale'" [valueInput]="element.causale"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Soggetto pagatore'"
	[valueInput]="element.soggettoPagatore?.parte.nominativo"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
	[labelInput]="'Data incasso'" [valueInput]="element.dataIncasso"></div>
<div labelTextInput class="col-sm-3 bloccodati"
	[typeLabel]="'importo'" [labelInput]="'Totale'"
	[valueInput]="element.importo+element.interessi+element.spese+element.compensoAvvocati"></div>
<!-- </div> -->